module.exports = __webpack_public_path__ + "img/icn_receipt.cf053d6a.svg";